import axios from "axios";
import store from "redux/Store";
import { cfHeaderFieldType, textLengths } from "../../redux/Types";

export const validateClearanceWizard = async (data) => {
  const {  clearanceRuntime: { runtime }, } = store.getState();

  let errors = {};
  if (data) {

    let validateArray = data.fieldsToValidate || [];
    // let validateArray =  [];
    if (validateArray.findIndex(d => d.id === "programmeType") !== -1 && !data.programmeType) {
      errors.programmeType = "Programme Type should not be empty.";
    } else if (runtime && runtime._config && runtime._config.PROGRAMME_TYPES && data.programmeType && data.programmeType === runtime._config.PROGRAMME_TYPES.EPISODE && !data.selectedMasterForm) {
      if (data.id && !data.seriesTitle) {
        errors.programmeType = "Select a series to proceed.";
      } else if (!data.id) {
        errors.programmeType = "Select a series to proceed.";
      } else if (data.id && data.seriesTitle && errors.programmeType) {
        delete errors.programmeType
      }
    }

    if (validateArray.length > 0) {
      for (let index = 0; index < validateArray.length; index++) {
        let item = validateArray[index];

        if (item && item.required) {
          if (
            (item.type !== cfHeaderFieldType.NUMBER && !data[item.id]) ||
            (item.type === cfHeaderFieldType.NUMBER && (data[item.id] === undefined || data[item.id] === null || data[item.id] === "" || isNaN(Number(data[item.id])))) ||
            (data[item.id] && item?.subFields?.length> 0) ||
            (item.type === cfHeaderFieldType.DATE_RANGE && (!Array.isArray(data[item.id]) || !data[item.id].length || data[item.id].length === 1)) ||
            ((item.type === cfHeaderFieldType.TEXT || item.type === "selfSearch") && `${data[item.id]}`.trim() === "")
          ) {
            if(item?.subFields?.length> 0){
              let subFields = item.subFields;
              // let subFieldsErrors = [];
              subFields.forEach(subItem => {
                if (subItem.required) {
                  if (
                    (item.type !== cfHeaderFieldType.NUMBER && !data[item.id]) ||
                    (item.type === cfHeaderFieldType.NUMBER && (data[item.id] === undefined || data[item.id] === null || data[item.id] === "" || isNaN(Number(data[item.id])))) ||
                    (subItem.type !== cfHeaderFieldType.NUMBER && !data[item.id][subItem.key]) ||
                    (subItem.type === cfHeaderFieldType.NUMBER && (data[item.id][subItem.key] === undefined || data[item.id][subItem.key] === null || data[item.id][subItem.key] === "" || isNaN(Number(data[item.id][subItem.key])))) ||
                    (subItem.type === cfHeaderFieldType.DATE_RANGE && (!Array.isArray(data[item.id][subItem.key]) || !data[item.id][subItem.key].length || data[item.id][subItem.key].length === 1)) ||
                    ((subItem.type === cfHeaderFieldType.TEXT || subItem.type === "selfSearch") && `${data[item.id][subItem.key]}`.trim() === "")
                  ) {
                    // subFieldsErrors.push(subItem.key);
                    errors[item.id] = {
                      ...(errors[item.id] ?? {}),
                      [subItem.key]: `Should not be empty`,
                    };
                  }
                }
              });
              // if(subFieldsErrors.length > 0){
              //   errors[item.id] = `Should not be empty`;
              // }
            }else{
              errors[item.id] = `Should not be empty`;
            }
          }
        }
        if (item.subQuestions && item.subQuestions.length > 0) {
          item.subQuestions.forEach(sItem => {
            if (sItem && sItem.required) {

              if (
                !data[sItem.id] ||
                (sItem.type === cfHeaderFieldType.DATE_RANGE && (!Array.isArray(data[sItem.id]) || !data[sItem.id].length || data[item.id].length === 1)) ||
                ((sItem.type === cfHeaderFieldType.TEXT || sItem.type === "selfSearch") && `${data[sItem.id]}`.trim() === "")
              ) {

                if (sItem.visibleOn && sItem.visibleOn.length > 0) {
                  sItem.visibleOn.map(v => {
                    if (v.operator && v.operator === "AND") {
                      if (v.visibleCondition.map(c => data[c.key] === c.value).every(k => k)) {
                        errors[sItem.id] = `Should not be empty`;
                      }
                    } else if (data[v.key] === v.value) {
                      errors[sItem.id] = `Should not be empty`;
                    }
                  })
                }

              }

            }
            // text length check of sub text items
            if (data[sItem.id] && (sItem.type === cfHeaderFieldType.TEXT || sItem.type === "selfSearch") && data[sItem.id].length > (item.maxLength ?? textLengths.TEXT)) {
              errors[sItem.id] = `Should be less than ${(item.maxLength ?? textLengths.TEXT)} characters.`;
            }
          });
        }
        // text length check
        if (data[item.id] && (item.type === cfHeaderFieldType.TEXT || item.type === "selfSearch") && data[item.id].length > (item.maxLength ?? textLengths.TEXT)) {
          errors[item.id] = `Should be less than ${(item.maxLength ?? textLengths.TEXT)} characters.`;
        }

        if (data['episodeCount'] && data['episodeCount'] < 0) {
          errors['episodeCount'] = `Invalid episode count`;
        }

        if (item.uniqueValue && !errors[item.id]) {
          let isUnique = await validateUniqueValue(item, data[item.id], data.id ? data.id : "") ?? false;
          if (!isUnique) {
            errors[item.id] = `${item?.label} already in use`;
          }
        }


      }
    }

  }
  if (Object.entries(errors).length === 0) {
    return null;
  } else {
    return errors;
  }
};

export const validateUniqueValue = (field, value, cfId, done = null) =>{
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  
return new Promise((resolve)=>{
    axios
    .post(
      `${orgID}/mllic/forms/checkCFUniqueValue`,
      { cfId: cfId, field: field.id, value: value }
  )
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      resolve(true);
    });
});


}